import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, Col, Row, Card, CardBody } from 'reactstrap';
import { connect } from 'react-redux';
import MapIcon from '@mui/icons-material/Map';
import CodeIcon from '@mui/icons-material/Code';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import DescriptionIcon from '@mui/icons-material/Description';
import SaveIcon from '@mui/icons-material/Save';

const required = value => value ? undefined : 'Required'

const renderCompactField = ({ input, placeholder, type, meta: { touched, error, warning }, disabled, icon: Icon }) => (
    <div>
        <div className={`input-group input-group-sm ${touched && error ? 'has-validation' : ''}`}>
            {Icon && (
                <span className="input-group-text bg-light border-end-0 text-muted" style={{ padding: '0.25rem 0.5rem' }}>
                    <Icon style={{ fontSize: '1rem' }} />
                </span>
            )}
            <input
                {...input}
                className={`form-control form-control-sm ${touched && error ? 'is-invalid' : ''} ${Icon ? 'border-start-0' : ''}`}
                placeholder={placeholder}
                type={type}
                disabled={disabled}
                style={{ fontSize: '0.85rem' }}
            />
            {touched && ((error && <div className="invalid-feedback">{error}</div>) || (warning && <div className="text-warning small">{warning}</div>))}
        </div>
    </div>
);

const DeliveryRateAddOrUpdate = ({ handleSubmit, data }) => {
    return (
        <form className="p-1" onSubmit={handleSubmit}>
            <Card className="border-0 shadow-sm mb-3">
                <CardBody className="p-3">
                    <div className="d-flex align-items-center mb-3 text-primary border-bottom pb-2">
                        <MapIcon style={{ fontSize: '1.2rem' }} className="me-2" />
                        <h6 className="m-0 fw-bold small text-uppercase">Zone & Rate Information</h6>
                    </div>

                    <Row className="g-3">
                        <Col md={6}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-1" style={{ fontSize: '0.75rem' }}>
                                    Zone Name <span className='text-danger'>*</span>
                                </label>
                                <Field
                                    name="areaName"
                                    component={renderCompactField}
                                    type="text"
                                    placeholder="Enter Zone Name"
                                    validate={[required]}
                                    icon={MapIcon}
                                />
                            </div>
                        </Col>

                        <Col md={6}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-1" style={{ fontSize: '0.75rem' }}>
                                    Zone Code <span className='text-danger'>*</span>
                                </label>
                                <Field
                                    name="areaCode"
                                    component={renderCompactField}
                                    type="text"
                                    placeholder="Enter Zone Code"
                                    validate={[required]}
                                    icon={CodeIcon}
                                />
                            </div>
                        </Col>

                        <Col md={6}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-1" style={{ fontSize: '0.75rem' }}>
                                    Zone Rate <span className='text-danger'>*</span>
                                </label>
                                <Field
                                    name="rate"
                                    component={renderCompactField}
                                    type="text"
                                    placeholder="Enter Delivery Rate"
                                    validate={[required]}
                                    icon={AttachMoneyIcon}
                                />
                            </div>
                        </Col>

                        <Col md={6}>
                            <div className="mb-1">
                                <label className="form-label fw-bold text-muted small mb-1" style={{ fontSize: '0.75rem' }}>
                                    Description
                                </label>
                                <div className="input-group input-group-sm">
                                    <span className="input-group-text bg-light border-end-0 text-muted" style={{ padding: '0.25rem 0.5rem' }}>
                                        <DescriptionIcon style={{ fontSize: '1rem' }} />
                                    </span>
                                    <Field
                                        name="description"
                                        component="textarea"
                                        className="form-control form-control-sm border-start-0"
                                        placeholder="Enter Description..."
                                        style={{ fontSize: '0.85rem', minHeight: '32px' }}
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            <div className="d-flex justify-content-end pt-2 mt-2 border-top">
                <Button
                    color="primary"
                    type="submit"
                    size="sm"
                    className="px-4 py-2 rounded-pill shadow-sm d-flex align-items-center"
                    style={{
                        background: 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
                        border: 'none',
                        fontWeight: 'bold',
                        fontSize: '0.85rem'
                    }}
                >
                    <SaveIcon style={{ fontSize: '1rem' }} className="me-2" />
                    {data ? 'Update Rate' : 'Save Rate'}
                </Button>
            </div>
        </form>
    );
};

DeliveryRateAddOrUpdate.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    data: PropTypes.object,
};

const mapStateToProps = (state, data) => {
    if (data && data?.data) {
        return {
            initialValues: {
                deliveryAreaId: data?.data?.deliveryAreaId,
                areaName: data?.data?.areaName,
                rate: data?.data?.rate,
                areaCode: data?.data?.areaCode,
                description: data?.data?.description,
            }
        }
    }
}

export default connect(mapStateToProps)(reduxForm({ form: 'deliveryRateAddOrUpdateform', enableReinitialize: true })(DeliveryRateAddOrUpdate))